currentFetchPolicy